import React, { useState, useEffect } from 'react';
import { Form } from 'react-form';

import Popup from '../../Popup';
import { Input } from '../../Form';

import { required } from '../../../utils/form-validation';

const AddEditTeamStandingPopUp = ({
    onCloseClick,
    teamPopUpAction,
    addTeamStanding,
    eventId,
    selectedTeamStanding,
    editTeamStanding,
}) => {
    const [defaultFormValues, setDefaultFormValues] = useState(null);

    useEffect(() => {
        if (selectedTeamStanding && selectedTeamStanding.id) {
            setDefaultFormValues({ ...selectedTeamStanding });
        } else {
            setDefaultFormValues({});
        }
    }, []);

    const handleSubmit = (values) => {
        if (teamPopUpAction === 'add') {
            addTeamStanding(eventId, values);
        } else if (teamPopUpAction === 'edit') {
            editTeamStanding(eventId, values);
        }
    };

    if (defaultFormValues) {
        return (
            <Popup
                className={`popup-md clear-over-flow`}
                onCloseClick={onCloseClick}
                config={{
                    noPadding: true,
                    fullScreen: false,
                    topGradient: false,

                    style: {
                        overflowY: 'scroll',
                    },
                }}
            >
                <div className="w-100">
                    <div className="p-3 text-uppercase">
                        <h6>
                            {teamPopUpAction === 'add' ? 'New' : 'Edit'} Team
                        </h6>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <Form
                            onSubmit={handleSubmit}
                            defaultValues={defaultFormValues}
                        >
                            {({ submitForm }) => {
                                return (
                                    <form id="edit-add-team-standing" className="w-100 flex-column justify-content-start align-items-center" onSubmit={submitForm}>
                                        <div className="w-100 align-self-center">
                                            <div className="row">
                                                <div className="col-md-4 offset-md-1">
                                                    <Input
                                                        type="number"
                                                        field="rank"
                                                        label="Rank"
                                                        id="rank"
                                                        name="rank"
                                                        validate={required}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8 offset-md-1">
                                                    <Input
                                                        type="text"
                                                        field="teamName"
                                                        id="teamName"
                                                        name="teamName"
                                                        label="Team Name"
                                                        validate={required}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-md-8 offset-md-1">
                                                    <Input
                                                        type="text"
                                                        field="homeClub"
                                                        label="Home Club"
                                                        validate={required}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8 offset-md-1">
                                                    <label>Team Record</label>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-5 offset-md-1">
                                                    <div className="d-flex flex-row justify-content-space-between align-items-center">
                                                        <p className="text-small m-0 mr-2 align-self-center">Wins</p>
                                                        <Input
                                                            type="number"
                                                            field="teamRecordWins"
                                                            validate={required}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="d-flex flex-row justify-content-space-between align-items-center">
                                                        <p className="text-small m-0 mr-2 align-self-center">Losses</p>
                                                        <Input
                                                            type="number"
                                                            field="teamRecordLosses"
                                                            validate={required}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8 offset-md-1">
                                                    <label>Match Record</label>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-5 offset-md-1">
                                                    <div className="d-flex flex-row justify-content-space-between align-items-center">
                                                        <p className="text-small m-0 mr-2 align-self-center">Wins</p>
                                                        <Input
                                                            type="number"
                                                            field="matchRecordWins"
                                                            validate={required}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="d-flex flex-row justify-content-space-between align-items-center">
                                                        <p className="text-small m-0 mr-2 align-self-center">Losses</p>
                                                        <Input
                                                            type="number"
                                                            field="matchRecordsLosses"
                                                            validate={required}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-8 offset-md-1">
                                                    <label>Sets</label>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-5 offset-md-1">
                                                    <div className="d-flex flex-row justify-content-space-between align-items-center">
                                                        <p className="text-small m-0 mr-2 align-self-center">Wins</p>
                                                        <Input
                                                            type="number"
                                                            field="setsWins"
                                                            validate={required}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="d-flex flex-row justify-content-space-between align-items-center">
                                                        <p className="text-small m-0 mr-2 align-self-center">Losses</p>
                                                        <Input
                                                            type="number"
                                                            field="setsLosses"
                                                            validate={required}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-6 offset-md-1">
                                                    <div className="d-flex flex-row justify-content-between align-items-baseline">
                                                        <Input
                                                            type="number"
                                                            field="gamePercentage"
                                                            label="Games Won Percentage"
                                                            validate={required}
                                                        />
                                                        <p className="text-medium align-self-center m-0 ml-3">%</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row p-3 d-flex flex-row justify-content-end align-items-center">
                                                <div className="col-md-4 offset-md-6">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-primary btn-lg"
                                                    >
                                                        Save
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                );
                            }}
                        </Form>
                    </div>
                </div>
            </Popup>
        );
    }

    return null;
};

export default AddEditTeamStandingPopUp;
